import apiClient from '@/services/rest-api-tools/apiClient'

const baseEndpoint = '/device'

export const get = async (imei, region) => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/${imei}`,
    headers: {
        "X-Region": region,
    }
  })

  return response
}
